import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { catalogItemActions } from 'entities/CatalogItem/model/slices/CatalogItemSlice';
import {
    getRouteGlobalCatalogItem,
    getRouteOrderCatalogCategoriesItem,
    getRoutePropertiesCatalogItem,
} from 'shared/const/router';
import { useAppDispatch } from 'shared/lib/hooks/useAppDispatch';

export interface UseExpandDetailedViewParams {
    id: string;
    isSearch?: boolean;
    isMoveToCatalogMode: boolean;
    isGlobalCatalog: boolean | undefined;
    selectedPropertyId: string | undefined;
    selectedCategoryId: string | undefined;
    selectedOrderId: string | undefined;
    selectedPropertyCatalogId: string | undefined;
}

export const useExpandDetailedView = ({
    id,
    isSearch,
    isMoveToCatalogMode,
    isGlobalCatalog,
    selectedPropertyId,
    selectedCategoryId,
    selectedOrderId,
    selectedPropertyCatalogId,
}: UseExpandDetailedViewParams) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    return useCallback(() => {
        dispatch(catalogItemActions.setSelectedItemById(id));
        dispatch(catalogItemActions.setShowDetailedView(true));

        if (isSearch) {
            return;
        }

        if (isMoveToCatalogMode) {
            if (isGlobalCatalog) {
                navigate(
                    getRouteGlobalCatalogItem(
                        selectedPropertyId,
                        selectedCategoryId,
                        id,
                    ),
                );
            } else {
                navigate(
                    getRoutePropertiesCatalogItem(
                        selectedPropertyId,
                        selectedCategoryId,
                        id,
                    ),
                );
            }
        } else {
            navigate(getRouteOrderCatalogCategoriesItem(id), {
                state: {
                    selectedOrderId,
                    selectedPropertyCatalogId,
                    selectedPropertyId,
                    fromOrder: selectedOrderId,
                },
            });
        }
    }, [
        dispatch,
        id,
        isSearch,
        isMoveToCatalogMode,
        isGlobalCatalog,
        navigate,
        selectedCategoryId,
        selectedOrderId,
        selectedPropertyCatalogId,
        selectedPropertyId,
    ]);
};
